import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Heading } from 'grommet';
import ResourceCard from '../ResourceCard';
import { Button } from '../Button';
import {
  StyledCardsList,
  StyledCardsGrid,
  StyledLoadMore,
  StyledCardItem,
  StyledErrorMessage,
} from './ResourceBrowserCardsListStyle';

const ErrorMessage = () => (
  <StyledErrorMessage>
    <div>
      <Heading level="2">No content found</Heading>
      <Heading level="4" margin={{ top: '20px' }}>
        Try resetting your filters or broadening your search.
      </Heading>
    </div>
  </StyledErrorMessage>
);

const ResourceBrowserCardsList = ({ cards, pageSize }) => {
  const [limit, setLimit] = useState(pageSize);

  const buttonText = () => {
    // If the remaining cards is less than a whole page...
    if (cards.length - limit < pageSize) {
      return `Load ${cards.length - limit} more`;
    }
    // Otherwise, say load n more
    return `Load ${pageSize} more`;
  };

  // As long as there's more cards than the limit left, show the button  */}
  const handleLoadMore = () => {
    setLimit(limit + pageSize);
  };

  const showLoadMore = cards.length > limit;

  return (
    <StyledCardsList>
      <div>
        {cards.length > 0 ? (
          <StyledCardsGrid>
            {cards.slice(0, limit).map((resource) => (
              <StyledCardItem key={resource.slug}>
                <ResourceCard layout="vertical" {...resource} />
              </StyledCardItem>
            ))}
          </StyledCardsGrid>
        ) : (
          <ErrorMessage />
        )}

        {cards.length > 0 && showLoadMore && (
          <StyledLoadMore align="center">
            <Button
              type="button"
              onClick={() => handleLoadMore()}
              label={buttonText()}
            />
          </StyledLoadMore>
        )}
      </div>
    </StyledCardsList>
  );
};

ResourceBrowserCardsList.propTypes = {
  pageSize: PropTypes.number.isRequired,
  cards: PropTypes.arrayOf(PropTypes.object).isRequired,
};
export default ResourceBrowserCardsList;
